import { render, staticRenderFns } from "./PairRanks.vue?vue&type=template&id=3810a33c&scoped=true&"
import script from "./PairRanks.vue?vue&type=script&lang=js&"
export * from "./PairRanks.vue?vue&type=script&lang=js&"
import style0 from "./PairRanks.vue?vue&type=style&index=0&id=3810a33c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3810a33c",
  null
  
)

export default component.exports